// Invitación al quiz en la ficha de producto. Liviano a propósito: la ficha no
// carga el motor (quiz.js) cuando la invitación enlaza a la página del quiz.
//
// Hace cuatro cosas:
//   1. Mide la invitación: afh_quiz_entry_view (se vio) y afh_quiz_entry_click.
//      Es el denominador del embudo: sin él no hay tasa de inicio. Va directo al
//      dataLayer porque quiz-tracking.js vive en la página del quiz.
//   2. Una llamada de atención, una sola vez, cuando la invitación entra en
//      pantalla. No es un pulso en bucle: convive con «Agregar al carrito».
//   3. La barra anclada en móvil, si el bloque la activa.
//   4. En modo ventana, importa el motor (quiz.js, ~20 KB) al primer clic en
//      la invitación, no al cargar la ficha: así no pesa en cada ficha.

(() => {
  if (window.__quizEntrada) return;
  window.__quizEntrada = true;

  const empujar = (evento, datos) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `afh_${evento}`, ...datos });
  };
  const datosDe = (el) => ({
    quiz_id: el.dataset.quizEntry,
    product_id: el.dataset.quizProducto ? `shopify_${el.dataset.quizProducto}` : undefined,
  });
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.quiz-entry').forEach((entry) => {
    if (entry.dataset.quizEntradaLista) return;
    entry.dataset.quizEntradaLista = '1';

    entry.querySelector('[data-quiz-entry-cta]')?.addEventListener('click', () => {
      if (entry.dataset.quizEntry) empujar('quiz_entry_click', datosDe(entry));
    });

    if (!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => {
          if (!e.isIntersecting) return;
          obs.disconnect();
          if (entry.dataset.quizEntry) empujar('quiz_entry_view', datosDe(entry));
          if (reducido || !entry.hasAttribute('data-quiz-cue')) return;
          // Un respiro tras aparecer: animar durante el desplazamiento no se ve.
          setTimeout(() => {
            entry.classList.add('is-cue');
            setTimeout(() => entry.classList.remove('is-cue'), 2600);
          }, 700);
        });
      },
      { threshold: 0.6 },
    );
    obs.observe(entry);
  });

  // Modo ventana: el motor se importa al pulsar. Al terminar la importación,
  // quiz.js ya registró su propio manejador de apertura y se repite el clic.
  let motor = null;
  document.querySelectorAll('[data-quiz-open][data-quiz-motor]').forEach((boton) => {
    boton.addEventListener('click', async (evento) => {
      if (window.__quizMotorListo) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      motor = motor || import(boton.dataset.quizMotor);
      await motor;
      window.__quizMotorListo = true;
      boton.click();
    });
  });

  // Barra anclada en móvil: aparece al pasar la invitación y se puede cerrar.
  // Una vez cerrada no vuelve en la sesión.
  document.querySelectorAll('[data-quiz-bar]').forEach((bar) => {
    const clave = 'quiz-bar-cerrada';
    let cerrada = false;
    try {
      cerrada = sessionStorage.getItem(clave) === '1';
    } catch {
      /* modo privado: se comporta como no cerrada */
    }
    const ancla = document.querySelector(bar.dataset.quizBarAfter || '.quiz-entry');
    if (cerrada || !ancla || !('IntersectionObserver' in window)) return bar.remove();

    const obs = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0));
      },
      { threshold: 0 },
    );
    obs.observe(ancla);

    bar.querySelector('[data-quiz-bar-close]')?.addEventListener('click', () => {
      bar.classList.remove('is-on');
      obs.disconnect();
      try {
        sessionStorage.setItem(clave, '1');
      } catch {
        /* sin sessionStorage: solo se oculta en esta vista */
      }
      setTimeout(() => bar.remove(), 400);
    });
  });
})();
